module.exports = __webpack_public_path__ + "img/1440.89a3801a.jpg";